import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';
import styles from './RefillCountDisplay.css';

const RefillCountDisplay = ({ refillsRemaining, totalRefills }) => ({
  render() {
    const possibleRefillNumber = totalRefills - refillsRemaining + 1;
    const thisWillbeRefillNumber = Math.min(possibleRefillNumber, totalRefills);
    const includeCircles = thisWillbeRefillNumber > 0 && totalRefills <= 5;

    return (
      <div className={styles.container}>
        {includeCircles ? (
          <div className={styles.dotContainer}>
            {_.range(totalRefills).map(
              num =>
                num < thisWillbeRefillNumber ? (
                  <span key={num} className={styles.dotFull} />
                ) : (
                  <span key={num} className={styles.dot} />
                )
            )}
          </div>
        ) : null}
        <span
          className={
            styles.countText + (includeCircles ? '' : styles.skipCircles)
          }
        >
          Refill {thisWillbeRefillNumber} of {totalRefills}
        </span>
      </div>
    );
  },
});

RefillCountDisplay.propTypes = {
  refillsRemaining: PropTypes.number.isRequired,
  totalRefills: PropTypes.number.isRequired,
};

export default RefillCountDisplay;



// WEBPACK FOOTER //
// ./src/containers/CartPage/RefillCountDisplay.jsx